"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var Code = function Code(props) {
  var className = props.className,
      rest = (0, _objectWithoutProperties2.default)(props, ["className"]);
  return _react.default.createElement("code", Object.assign({}, rest, {
    className: (0, _classnames.default)(className, 'private-code')
  }));
};

var _default = Code;
exports.default = _default;
Code.displayName = 'Code';
module.exports = exports.default;